import { IModel, Model, ModelRecord } from './Model';
import { defaultTo, map, orderBy } from 'lodash';
import {
  IRabiesInformationContentModel,
  RabiesInformationContentModel,
} from './RabiesInformationContentModel';

export interface IRabiesInformationModel extends IModel {
  rabiesInformationId: number;
  vaccineAdministeredName: string;
  vaccineManufacturerName: string;
  vaccineName: string;
  vaccineVirusTypeName: string;
  fullName: string;
  contents: IRabiesInformationContentModel[];
  serialNumber: string;
  lotNumber: string;
  expirationDate: string;
  addNewLotNumber: boolean;
}

export class RabiesInformationModel
  extends Model
  implements ModelRecord<IRabiesInformationModel>
{
  rabiesInformationId: number;
  vaccineAdministeredName: string;
  vaccineManufacturerName: string;
  vaccineName: string;
  vaccineVirusTypeName: string;
  fullName: string;
  contents: IRabiesInformationContentModel[] = [];
  serialNumber: string;
  lotNumber: string;
  expirationDate: string;
  addNewLotNumber: boolean;

  constructor(params?: Partial<IRabiesInformationModel>) {
    super(params);

    this.rabiesInformationId = defaultTo(params?.rabiesInformationId, 0);
    this.vaccineAdministeredName = defaultTo(
      params?.vaccineAdministeredName,
      '',
    );
    this.vaccineManufacturerName = defaultTo(
      params?.vaccineManufacturerName,
      '',
    );
    this.vaccineName = defaultTo(params?.vaccineName, '');
    this.vaccineVirusTypeName = defaultTo(params?.vaccineVirusTypeName, '');
    this.fullName = defaultTo(params?.fullName, '');
    this.serialNumber = defaultTo(params?.serialNumber, '');
    this.lotNumber = defaultTo(params?.lotNumber, '');
    this.expirationDate = defaultTo(
      params?.expirationDate,
      new Date().toISOString().split('T')[0],
    );
    this.addNewLotNumber = defaultTo(params?.addNewLotNumber, false);
    map(
      orderBy(params?.contents, (v) => v.rabiesInformationContentId),
      (content) => {
        this.contents.push(new RabiesInformationContentModel(content));
      },
    );
  }
}
